import React, { useState } from 'react';

import Modal from '../components/Shell/Modal';
import { TemplateField } from '../components/Attributes/Attributes_old';
import Button from '../components/Button';

import { addContact } from '../api/contacts';

import useRequired from '../hooks/useRequired';
import useModal from '../hooks/useModal';
import useAsync from '../hooks/useAsync';

const MODAL_NAME = 'addVendorModal';

const QuickAddVendor = () => {
	const [formVendor, setFormVendor] = useState({});

	const { open: options, setClose } = useModal(MODAL_NAME);

	const { execute: onAddVendor, status: isAddingVendor } = useAsync(
		addContact,
		{ immediate: false }
	);

	return (
		<Modal title="Quick Add Vendor" open={!!options} onClose={() => setClose()}>
			<div className="grid grid-cols-2 gap-y-4 gap-x-4 text-left">
				<TemplateField
					name="Company Name"
					required
					onChange={(i, name) =>
						setFormVendor({ ...formVendor, companyName: name })
					}
				/>
				<TemplateField
					name="Email"
					onChange={(i, email) => setFormVendor({ ...formVendor, email })}
				/>
				<TemplateField
					name="Phone Number"
					onChange={(i, phone) => setFormVendor({ ...formVendor, phone })}
				/>
				<TemplateField
					name="URL"
					onChange={(i, url) => setFormVendor({ ...formVendor, url })}
				/>
			</div>
			<div className="flex justify-end mt-6">
				<Button
					onClick={() => {
						onAddVendor({ ...formVendor, type: 'company' }, (response) => {
							if (typeof options?.onSubmit === 'function') {
								options?.onSubmit({
									label: response.companyName,
									value: response.id,
									response,
								});
								setFormVendor({});
							}
							setClose();
						});
					}}
					disabled={!useRequired(formVendor, ['companyName'])}
				>
					{isAddingVendor === 'pending' ? 'Adding Vendor' : 'Add Vendor'}
				</Button>
			</div>
		</Modal>
	);
};

export default QuickAddVendor;
